















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
	props: {
		/**
		 * The source of the standard image
		 */
		src: {
			type: String,
		},
		/**
		 * The sources of the image in case they differ for different screen sizes
		 */
		srcset: {
			type: [Array, String],
		},
		/**
		 * The different screen sizes for which the images differ
		 */
		sizes: {
			type: [Array, String],
		},
		/**
		 * Alternative text in case the image is not loaded
		 */
		alt: {
			type: String,
		},
	}
});
